export default class ActionType {
    static REGISTER = 'register';
    static EDIT     =  "edit";
    static DELETE   =  "delete";
}